(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BT-whatsapp"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
